import { useEffect } from "react";
import { useSellarCurrentBusiness } from "../../../../hooks/useSellarCurrentBusiness.shared";
import { NavigationBarMenu } from "../../../../components/navigation/NavigationBar";
import { useMenuDrawerContext } from "../../../../components/menu/MenuDrawerContextProvider.shared";
import { useLegalEntityCompanyCreditInfo } from "../../../../hooks/api/v2/legalEntity/useLegalEntityCompanyCreditInfo";
import { TwoSellarCreditGetStartedContent } from "./TwoSellarCreditGetStarted";

export const SellarCreditGetStarted = () => {
  const { setDisplayType } = useMenuDrawerContext();

  // on page load, make sidebar rail though not enforced
  useEffect(() => {
    setDisplayType("rail");
  }, [setDisplayType]);

  const { business } = useSellarCurrentBusiness();

  const { data: creditInfo } = useLegalEntityCompanyCreditInfo({
    RetailerId: business?.Retailer?.id ?? 0,
  });

  return (
    <>
      <NavigationBarMenu title={"Sellar Credit"} />

      {creditInfo?.creditProvider === "two" ? (
        <TwoSellarCreditGetStartedContent />
      ) : null}
    </>
  );
};
